import React, { useCallback, useEffect, useState } from "react";
import api, { formatApiError, formatTanggal } from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_GURU } from "@/lib/nav";
import { toast } from "sonner";
import { Plus, X, Send } from "lucide-react";

export function KendalaGuru() {
  const [items, setItems] = useState([]);
  const [show, setShow] = useState(false);
  const [isi, setIsi] = useState("");
  const load = useCallback(async () => { const { data } = await api.get("/kendala"); setItems(data); }, []);
  useEffect(() => { load(); }, [load]);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/kendala", { isi }); toast.success("Kendala terkirim"); setShow(false); setIsi(""); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const tandai = async (id) => { await api.post(`/kendala/${id}/tandai-tangani`); toast.success("Ditandai sudah ditangani"); load(); };
  return (
    <Layout nav={NAV_GURU}>
      <PageTitle title="Kendala Saya" action={<button onClick={() => setShow(true)} className="pp-btn-primary"><Plus className="w-4 h-4" />Input Kendala</button>} />
      {show && (
        <section className="pp-card p-6 mb-6 animate-fade-up">
          <div className="flex items-center justify-between mb-4"><h3 className="text-lg font-semibold">Sampaikan Kendala</h3><button onClick={() => setShow(false)}><X className="w-5 h-5 text-slate-400" /></button></div>
          <form onSubmit={submit} className="space-y-4">
            <textarea required rows={5} className="pp-input" placeholder="Tuliskan kendala Anda…" value={isi} onChange={(e) => setIsi(e.target.value)} />
            <div className="flex justify-end gap-2"><button type="button" onClick={() => setShow(false)} className="pp-btn-secondary">Batal</button><button type="submit" className="pp-btn-primary"><Send className="w-4 h-4" />Kirim Kendala</button></div>
          </form>
        </section>
      )}
      <section className="space-y-3">
        {items.length === 0 && <div className="pp-card p-10 text-center italic text-slate-400">Belum ada kendala.</div>}
        {items.map(k => (
          <div key={k.id} className="pp-card p-5">
            <div className="flex items-start justify-between mb-2">
              <div className="text-xs text-slate-500">{formatTanggal(k.created_at)}</div>
              <span className={k.status === "sudah_ditangani" ? "pp-badge-success" : "pp-badge-warning"}>{k.status === "sudah_ditangani" ? "Sudah Ditangani" : "Belum Ditangani"}</span>
            </div>
            <p className="text-slate-800 mb-3 whitespace-pre-wrap">{k.isi}</p>
            {k.tanggapan && (
              <div className="mb-3 p-3 rounded-lg bg-indigo-50 border border-indigo-100">
                <div className="text-[11px] uppercase tracking-wider text-indigo-700 font-semibold mb-1">
                  Tanggapan {k.tanggapan_role || ""}
                </div>
                <div className="text-sm text-slate-800 whitespace-pre-wrap">{k.tanggapan}</div>
                <div className="text-[11px] text-slate-500 mt-1">— {k.tanggapan_oleh || "—"}, {formatTanggal((k.tanggapan_at || "").slice(0, 10))}</div>
              </div>
            )}
            {k.status !== "sudah_ditangani" && <button onClick={() => tandai(k.id)} className="pp-btn-secondary text-xs">Tandai sudah ditangani</button>}
          </div>
        ))}
      </section>
    </Layout>
  );
}
